import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { ApiContext } from '../../contexts/ApiContext';
import { useProductsByIds } from '../../hooks/useProductsByIds';
import { getProductById } from '../../service/ApiLeiten';
import { assetUrl } from '../../utils/assets';
import { formatPriceUsd } from '../../utils/price';
import Spinner from '../spinner/Spinner';

export default function ProductCardKit({ product, type }) {

    const { rates } = useContext(ApiContext);
    const { products, loading } = useProductsByIds({ product, type });

    // Contenido de cada kit: { [idDelKit]: [productos que incluye] }
    const [kitContents, setKitContents] = useState({});

    useEffect(() => {
        // Los kits que hay que resolver salen de products, así que este efecto se
        // recalcula con products. No depende de kitContents (eso generaba el
        // warning de exhaustive-deps): se limpia y se vuelve a armar de cero.
        const kits = products.filter(item => item.kit);
        if (kits.length === 0) {
            setKitContents({});
            return;
        }

        let cancelled = false;

        Promise.all(
            kits.map(async (item) => {
                const ids = item.kit.split(',').map(id => id.trim()).filter(Boolean);
                const results = await Promise.allSettled(ids.map(id => getProductById(id)));
                const contents = results
                    .filter(result => result.status === 'fulfilled')
                    .map(result => result.value?.data)
                    .filter(entry => entry?.producto);

                return [item.producto.id, contents];
            })
        )
            .then(entries => {
                if (!cancelled) setKitContents(Object.fromEntries(entries));
            })
            .catch(error => console.error('Error cargando el contenido de los kits:', error));

        return () => { cancelled = true; };
    }, [products]);

    if (loading) return <Spinner />;

    if (products.length === 0) {
        return <h5 style={{ marginTop: '2rem' }}>No hay Datos disponibles</h5>;
    }

    return (
        <StyledProductCardKit>
            {products.map(item => {
                const { producto, precio } = item;
                const price = formatPriceUsd(precio, rates);
                const contents = kitContents[producto.id];

                return (
                    <div className="card" key={producto.id}>
                        <h4><strong>{producto.nombre_producto}</strong></h4>
                        <div className="card-grid">

                            {/* IZQUIERDA */}
                            <div className="card-left">
                                {producto.imagen_grande && (
                                    <img
                                        src={assetUrl(producto.imagen_grande)}
                                        className="card-img-top"
                                        alt={producto.nombre_producto}
                                    />
                                )}
                                <h6>Código: {producto.codigo}</h6>
                                <div className="price-container">
                                    {price && <button className="btn btn-warning btnPrice">{price}</button>}
                                </div>
                            </div>

                            {/* DERECHA */}
                            <div className="card-right">
                                <h5>Incluye</h5>

                                {!item.kit ? (
                                    <p>Sin detalle de contenido.</p>
                                ) : !contents ? (
                                    <Spinner />
                                ) : (
                                    <table className="kit-table">
                                        <tbody>
                                            {contents.map(entry => (
                                                <tr key={entry.producto.id}>
                                                    <td>
                                                        {entry.producto.imagen_grande && (
                                                            <img
                                                                src={assetUrl(entry.producto.imagen_grande)}
                                                                className="card-img-includes"
                                                                alt={entry.producto.nombre_producto}
                                                            />
                                                        )}
                                                    </td>
                                                    <td>{entry.producto.codigo}</td>
                                                    <td>{entry.producto.nombre_producto}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                        </div>
                    </div>
                );
            })}
        </StyledProductCardKit>
    );
}


const StyledProductCardKit = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.5rem;
    max-height: 630px;
    overflow-y: auto;

    .card {
        flex: 0 0 calc(50% - 0.5rem);
        max-width: calc(50% - 0.5rem);
        padding: 0.5rem;
    }

    .card-grid {
        display: grid;
        grid-template-columns: 45% 55%;
        gap: 0.5rem;
    }

    .card-left,
    .card-right {
        display: flex;
        flex-direction: column;
        gap: 0.4rem;
    }

    .card-img-top {
        width: 80%;
        object-fit: contain;
    }

    .card-img-includes {
        width: 50%;
    }

    .kit-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 0.85rem;
    }

    .kit-table td {
        padding: 0.3rem;
        border-top: 1px solid #ddd;
        vertical-align: middle;
        }
        
    .kit-table td:first-child  {
        text-align: center;
    }

    .price-container {
        margin: 1rem auto;
    }

    .btnPrice {
        width: 100%;
        padding: 0.6rem;
    }
`;
